import React, { useEffect, useState } from "react";
import styles from "./scss/blurtoast.module.scss";

type BlurToastDemoProps = {
  open: boolean;
  message?: React.ReactNode | ((close: () => void) => React.ReactNode);
  duration?: number;
  onClose?: () => void;
};

const BlurToastDemo: React.FC<BlurToastDemoProps> = ({
  open,
  message = "✅ Saved successfully",
  duration = 5000,
  onClose,
}) => {
  const [showToast, setShowToast] = useState(false);
  const [animateExit, setAnimateExit] = useState(false);

  useEffect(() => {
    let exitTimer: ReturnType<typeof setTimeout>;
    let removeTimer: ReturnType<typeof setTimeout>;

    if (open) {
      setShowToast(true);
      setAnimateExit(false);

      // auto fade-out after duration
      exitTimer = setTimeout(() => setAnimateExit(true), duration);

      // auto hide completely
      removeTimer = setTimeout(() => {
        setShowToast(false);
        onClose?.();
      }, duration + 600);
    }

    return () => {
      clearTimeout(exitTimer);
      clearTimeout(removeTimer);
    };
  }, [open, duration, onClose]);

  // 🔹 Manual close (instant, no delay)
  const handleImmediateClose = () => {
    setShowToast(false); // hide instantly
    onClose?.();
  };

  if (!showToast) return null;

  return (
    <div
      className={`${styles.toast} ${
        animateExit ? styles.toastExit : styles.toastEnter
      }`}
      role="status"
      aria-live="polite"
    >
      {typeof message === "function"
        ? message(handleImmediateClose) // 🔹 pass handler if message is JSX fn
        : message}

      {/* Default ❌ button inside */}
      <div
        onClick={handleImmediateClose}
        className={styles.closeButton}
        aria-label="Close"
      >
        
      </div>
    </div>
  );
};

export default BlurToastDemo;
